<template>
  <div></div>
</template>

<script>
import {post} from "../../http/api";

export default {
  name: "auth",
  created() {
    this.wxPcLoginMember();
  },
  methods: {
    wxPcLoginMember() {
      let param = {
        code: this.$route.query.code
      };
      this.post("memberInterfaces/v1.0/wxPcLoginMember", param).then(res => {
        // console.log("授权登录");
        let data = res.data;
        this.memberInfoInit(data);
        //如果没有绑定手机号去绑定手机号码
        if (data.member_id == '0') {
          this.redirect('/bindPhone')
          return;
        }
        if (Number(data.member_id)) {
          this.redirect('/home/index')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/login/auth.vue